export default __webpack_public_path__ + "static/media/willy.96dbde5b.jpg";